import { PSTFieldNames } from "@common/data-models/fields/pst-field-names";
import { ObjectTypes } from "@common/enums/object-types";
import { GroupValueHelpers, GroupKeyComparatorHelpers, RecordComparatorHelpers, ResultGroup, ResultGroupingDefinition, ResultGroup2, ResultGrouping2Definition } from "@common/data-models/search-results/result-group";
import { SearchResults } from "@common/data-models/search-results/search-results";
import { DataStore } from '@common/data-models/data-store/data-store';
import { Record } from "@common/data-models/records/record";
import { DraftRecord } from "@journal/data-models/records/draft-record";
import { IJournalService } from "@journal/interfaces/i-journal-service";

export class JournalSearchResults extends SearchResults {

    public static journalService: IJournalService = null;

    public drafts: Array<DraftRecord> = [];
    public addDraft(draft: DraftRecord) {
        this.drafts.push(draft);
        this.byGuid[draft.guid] = draft;
    }

    public getAllResults(): Array<Record> {
        let ret: Array<Record> = [];
        for (let draft of this.drafts) {
            ret.push(draft);
        }
        return ret;
    }

    public draftGroups: { [id: string]: ResultGroup<DraftRecord> } = {};

    private static _draftGroupDefs: { [id: string]: ResultGroupingDefinition } = {};
    public static get draftGroupDefs(): { [id: string]: ResultGroupingDefinition } {
        if ((Object.keys(JournalSearchResults._draftGroupDefs).length == 0)) {

            JournalSearchResults._draftGroupDefs[PSTFieldNames.PSTModTime] = new ResultGroupingDefinition(
                GroupValueHelpers.DateTime(PSTFieldNames.PSTModTime),
                GroupKeyComparatorHelpers.Value(),
                RecordComparatorHelpers.DateTime(PSTFieldNames.PSTModTime)
            );

        }
        return JournalSearchResults._draftGroupDefs;
    }

    private get draftGroupFields(): Array<string> {
        return JournalSearchResults.journalService.groupByDraftKeys;
    }

    public remove(rec: Record) {
        super.remove(rec);

        if (rec.type == ObjectTypes.DRAFT) {
            for (let i = 0; i < this.drafts.length; i++) {
                if (this.drafts[i].guid == rec.guid) {
                    this.drafts.splice(i, 1);
                    break;
                }
            }
            for (let field in JournalSearchResults.draftGroupDefs) {
                if (this.draftGroups[field]) this.draftGroups[field].remove(JournalSearchResults.draftGroupDefs[field].valueConvertor(rec),<DraftRecord>rec);
            }
        }
    }

    public sortGroups(sortBy: any, sortOrder: string, groupSortOrder: string) {
        if (this.objectType == ObjectTypes.DRAFT) {
            let groups = this.getGroups();

            for (let field of groups) {
                this.draftGroups[field].sort(JournalSearchResults.draftGroupDefs[field].groupKeyComparator(groupSortOrder), JournalSearchResults.draftGroupDefs[sortBy].recordComparator(sortOrder));
            }
        }
    }

    public dispose() {
        super.dispose();
        this.objectType = null;
        this.drafts = [];
        this.users = [];
        this.draftGroups = {};
    }

    public getGroups(): Array<string> {
        switch (this.objectType) {
            case ObjectTypes.DRAFT:
                return this.draftGroupFields;
            default:
                return ["Type"];
        }
    }

    public rebuildGroups(groupBy: string, sortBy: any, sortOrder: string, groupSortOrder: string) {
        if (this.objectType == ObjectTypes.DRAFT) {
            let groups = this.getGroups();
            // Clear all groups
            for (let field of groups) {
                if (!this.draftGroups[field]) this.draftGroups[field] = new ResultGroup<DraftRecord>();
                this.draftGroups[field].clear();
            }
            if (!this.draftGroups[SearchResults.groupByField]) {
                SearchResults.groupByField = groupBy;
            }
            // Build active group
            for (let draft of this.drafts) {
                this.draftGroups[SearchResults.groupByField].addToGroups(JournalSearchResults.draftGroupDefs[SearchResults.groupByField].valueConvertor(draft), draft);
            }
            this.draftGroups[SearchResults.groupByField].sort(JournalSearchResults.draftGroupDefs[SearchResults.groupByField].groupKeyComparator(groupSortOrder), JournalSearchResults.draftGroupDefs[sortBy].recordComparator(sortOrder));
            this.draftGroups[SearchResults.groupByField].isBuilt = true;

            // Build the rest of the groups
            for (let field of groups) {
                if (!this.draftGroups[field]) {
                    return;
                }
                if (this.draftGroups[field].isBuilt) {
                    continue;
                }
                let i = 0;
                for (let draft of this.drafts) {
                    this.draftGroups[field].addToGroups(JournalSearchResults.draftGroupDefs[field].valueConvertor(draft), draft);
                }
                this.draftGroups[field].sort(JournalSearchResults.draftGroupDefs[field].groupKeyComparator(groupSortOrder), JournalSearchResults.draftGroupDefs[sortBy].recordComparator(sortOrder));
                this.draftGroups[field].isBuilt = true;
            }
        }
    }
}
DataStore.registerSearchResults("journal", new JournalSearchResults());
